module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_0.414c1d17.png";